import ValidateDocumentActionTypes from './validate-document.types'
import { validateDocumentSignature } from '../../services/server-api/server-api.service'


const validateDocumentRequest = () => ({
  type: ValidateDocumentActionTypes.VALIDATE_DOCUMENT_REQUEST  
})

const validateDocumentSuccess = (data) => ({
    type: ValidateDocumentActionTypes.VALIDATE_DOCUMENT_SUCCESS,
    payload: data
  })

const validateDocumentFailure = (error) => ({
  type: ValidateDocumentActionTypes.VALIDATE_DOCUMENT_FAILURE,
  payload: error
})


export const validateDocument = (params) => {
  return async dispatch => {
    dispatch(validateDocumentRequest())
    try {
      const data = await validateDocumentSignature(params)
      dispatch(validateDocumentSuccess(data))
    } catch (error) {
      dispatch(validateDocumentFailure({message: error.message, data: error.data}))
    }
  }
}